import { SendDownloadLinksFormDataProvider } from '../dataProvider/SendDownloadLinksFormDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class SendDownloadLinksFormDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, SendDownloadLinksFormDataProvider);
  }
}
